<template>
  <el-dialog
    v-model="dialogShow"
    :title="obj.dialogTitle"
    :width="obj.dialogWidth"
    class="headbottom"
    :class="obj.class"
    :draggable="obj.draggable"
    :before-close="close"
    :destroy-on-close="obj.destroyOnClose"
  >
  <div class="dialog-body">
    <slot> </slot>
  </div>
    <template #footer v-if="obj.dialogIsFooter">
      <el-button type="info" plain size="large" @click="close">{{
        obj.dialogCloseBtnText
      }}</el-button>
      <el-button
        type="primary"
        @click="success"
        size="large"
        :loading="obj.loading"
        >{{ obj.dialogSuccessBtnText }}</el-button
      >
    </template>
  </el-dialog>
</template>

<script>
import { computed } from "vue";

export default {
  props: {
    dialogObject: {
      default() {
        return {};
      },
      type: Object,
    },
  },
  emits: ["dialogClose", "dialogSuccess"],
  setup(props, ctx) {
    // 处理props的数据 重新定义 dialogVisible
    const dialogShow = computed({
      get() {
        return props.dialogObject.dialogVisible;
      },
      set(val) {
        return val;
      },
    });
    const obj = computed({
      get() {
        return {
          dialogTitle: props.dialogObject.title || "",
          dialogWidth: props.dialogObject.width || "90%",
          dialogCloseBtnText: props.dialogObject.closeBtnText || "取 消",
          dialogSuccessBtnText: props.dialogObject.successBtnText || "确 定",
          dialogIsFooter: props.dialogObject.isFooter == undefined ? true : props.dialogObject.isFooter,
          loading: props.dialogObject.loading || false,
          draggable: props.dialogObject.loading || false,
          destroyOnClose: props.dialogObject.destroyOnClose == undefined ? true : false,
        }
      }
    });
    const close = () => {
      ctx.emit("dialogClose", false, "close");
    };
    const success = () => {
      ctx.emit("dialogSuccess", false, "success");
    };
    return { obj, dialogShow, close, success };
  },
};
</script>
<style lang="less" scoped>
.dialog-body {
  max-height: @dialogHeight;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
